
import { useEffect, useState } from "react";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";
import { ReportC02ConsumptionEditFormValues } from "services/api/reports/types";
import { initialReportC02ConsumptionEditForm } from "services/api/reports/consts";
import { useHandleDropdownChange } from "services/forms/hooks";
import { ReportC02ConsumptionProps } from "./types";



const ReportC02Consumption: React.FC<ReportC02ConsumptionProps> = (props) => {
  const { report } = props;

  const [pdfData, setPdfData] = useState<string | null>(null);

  const [scale, setScale] = useState<number>(1);
  const [formValues, setFormValues] = useState<ReportC02ConsumptionEditFormValues>(
    initialReportC02ConsumptionEditForm
  );

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth; // Dobijamo širinu ekrana
      const scaleFactor = width / 800; // Prilagođavamo faktor skaliranja na osnovu širine prozora
      setScale(scaleFactor); // Postavljamo novi faktor skaliranja
    };

    handleResize(); // Pozivamo ga odmah kako bi inicijalizovali veličinu pri učitavanju
    window.addEventListener("resize", handleResize); // Dodajemo event listener za promene veličine prozora

    return () => {
      window.removeEventListener("resize", handleResize); // Uklanjamo event listener kada se komponenta unmount-uje
    };
  }, []);

  // useEffect(() => {
  //   fetchReport();
  // }, [formValues.year]);

  // const fetchReport = async () => {
  //   setIsLoading(true);

  //   try {
  //     if (!!formValues.year) {
  //       let blob = await getReportC02ConsumptionAPI(formValues.year);
  //       const url = URL.createObjectURL(blob);
  //       setPdfData(url);
  //     }
  //   } catch {
  //     setIsLoading(false);
  //     return;
  //   }

  //   setIsLoading(false);

  //   setErrors({});
  // };

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, index) => currentYear - index);

  const yearItems: DropdownOption[] = years.map((year) => ({
    value: year.toString(),
    text: year.toString(),
  }));

  const handleDropdownChange = useHandleDropdownChange(
    setFormValues,
    formValues
  );

  return (
    <>
      <div className="mb-3">
        {/* <Dropdown
          name="year"
          placeholder="Odaberi godinu"
          options={yearItems}
          onChange={handleDropdownChange}
          size="small"
          value={formValues.year}
        /> */}
      </div>
      <div className="w-full h-full flex justify-center overflow-y-auto">
        <div className="w-full h-full max-h-full">
          {pdfData ? (
            <iframe
            src={pdfData}
            title={report.name}
            width="100%"
            height="100%"
            style={{ border: "none" }}
          ></iframe>
          ) : (
            <div className="flex justify-center items-center">
              Odaberite godinu
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ReportC02Consumption;
